import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("gw_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgSrc = (path) => {
  if (!path) return "";
  return /^https?:\/\//.test(path) ? path : `${API}/files/${path}`;
};

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const IMAGES = {
  hero1: "https://images.unsplash.com/photo-1616421004055-e6c780c51241?crop=entropy&cs=srgb&fm=jpg&q=80&w=2000",
  hero2: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=80&w=2000",
  hero3: "https://images.unsplash.com/photo-1684497404598-6e844dff9cde?crop=entropy&cs=srgb&fm=jpg&q=80&w=2000",
  oilGas: "https://images.unsplash.com/photo-1566995264330-32b0274ed1fc?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  realty: "https://images.unsplash.com/photo-1733244766159-f58f4184fd38?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  development: "https://images.unsplash.com/photo-1663659507002-304e741e9912?crop=entropy&cs=srgb&fm=jpg&q=80&w=2200",
};

export const COMPANIES = ["Grey Wolfe Limited", "Wolfe Realtors", "Grey Wolfe Development"];
